const actions = {
  SET_STATE: 'menu/SET_STATE',
  CHANGE_SETTING: 'menu/CHANGE_SETTING',
}

export default actions
